<template>
    <el-dialog title="页面链接" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small">
          <el-form-item label="渠道类型" :label-width="formLabelWidth">
             <el-select v-model="url_type" filterable placeholder="请选择" @change="selectOne">
              <el-option  label="小程序" value="wx"></el-option>
              <el-option  label="H5页面" value="mp"></el-option>
          </el-select>
          </el-form-item>
          <div v-if="url">
            <el-form-item label="标题" :label-width="formLabelWidth">
              <span>{{title}}</span>
            </el-form-item>
            <el-form-item v-if="source=='wx'" label="小程序appid" :label-width="formLabelWidth">
              <span>{{dataModel.wxapp_id}}</span>
              <el-button @click="submitFunc(dataModel.wxapp_id)" type="text" size="small">复制</el-button>
            </el-form-item>
            <el-form-item label="推荐人ID" :label-width="formLabelWidth">
              <el-input v-model="user_id"></el-input>
              <el-button @click="gen(url)" type="text" size="small">生成</el-button>
            </el-form-item>
            <el-form-item label="链接" :label-width="formLabelWidth">
              <span>{{url}}</span>
              <el-button @click="submitFunc(url)" type="text" size="small">复制</el-button>
            </el-form-item>
            <el-form-item label="手机预览" :label-width="formLabelWidth">
              <el-image style="width:150px;height:150px;" :src="qrcode_url"></el-image>
            </el-form-item>
          </div>
          
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import DataApi from '@/api/data.js';
    export default {
        data() {
            return {
                title:'',
                url_type:'',
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                qrcode_url:'',
                url:'',
                source:'',
                user_id:""
            };
        },
        props: ['is_open', 'dataModel','path_type'],
        created() {
          this.dialogVisible = this.is_open;
        },
        methods: {
          gen(){
            this.selectOne(this.source)
          },
          getQrcode(source) {
            let self = this;
            let info = self.dataModel;
            console.log(info)
           
            var page_id = self.path_type=='diypage'?info.page_id:info.product_id;
            let params = {
              app_id:info.app_id,
              source:source,
              type:self.path_type,
              page_id:page_id,
              user_id:self.user_id
            };
            DataApi.getQrcode(params,true)
            .then(res=>{
              this.qrcode_url = res.data.qrcode
              this.qrcodeVisible = true
            }).catch(error => {})
            // this.rules.coupon_id = row.coupon_id
            
          },
          selectOne(e) {
            let self = this
            if(self.dataModel.referee_id){
              self.user_id = self.dataModel.referee_id;
            }
            self.source = e;
            self.title = this.dataModel.page_name;
            var url = '';
            if(self.path_type=='product'){
              url = 'pages/product/detail/detail?product_id='+ this.dataModel.product_id+"&user_id="+self.user_id;
              self.title = this.dataModel.product_name;
            }
            if(self.path_type=='diypage'){
              url = "pages/diy-page/diy-page?page_id=" + this.dataModel.page_id;
              self.title = this.dataModel.page_name;
            }
            if(url==''){
              console.log('页面类型错误');return;
            }
            if (e == 'wx') {
                self.url = url;    //拼接多个赋值
              }else{
                self.url = window.location.protocol + '//' + window.location.host + "/h5/#/"+url + "&app_id=" + this.dataModel.app_id;    //拼接多个赋值
              }
              self.getQrcode(e);
          },
            /*确认事件*/
            submitFunc(value='') {
              var copyContent = document.createElement('input');     //创建一个隐藏input（重要！）
              copyContent.value = value
              document.body.appendChild(copyContent);
              copyContent.select(); // 选择对象
              document.execCommand("Copy"); // 执行浏览器复制命令
              this.$message.success("复制成功！");
              copyContent.remove();
            },


            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('closeDialog', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/page/path.vue